// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

const styles = theme => ({
  container: {
    margin: '14px -14px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    [theme.breakpoints.down(549)]: {
      flexDirection: 'column',
      margin: '14px 0',
    },
  },
});

export default styles;
